import React from 'react';

const Quotes = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Quotes</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Quotes management page</p>
      </div>
    </div>
  );
};

export default Quotes;